import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import { getUrlParamByName } from "./utils/helpers";
let locale =
  getUrlParamByName(location.search, "locale") ||
  getUrlParamByName(location.search, "ui_locales") ||
  "en_US";
locale = locale.replace("_", "-").toLowerCase();
i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === "development",
    lng: locale,
    backend: {
      loadPath:
        LOCAL_ENV === "true"
          ? "/locales/{{lng}}.json"
          : "/assets/privacy-signup/locales/{{lng}}.json",
    },
    nsSeparator: "::",
    keySeparator: false,
    lowerCaseLng: true,
    load: "currentOnly",
    fallbackLng: "en-us",
    react: {
      wait: false,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
    },
  });

export default i18n;
